import { AddBusiness as AddBusinessIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, Card, MenuItem, Stack, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { TimeHelper } from 'src/utils/time-helper';
import { getStartedCardSx, getStartedHeaderSx, StepHeader } from './getStartedShared';

export default function GetStartedBrandStep({
  brandForm,
  setBrandForm,
  orgComplete,
  brandComplete,
  savingStep,
  onSave,
  onSkip,
}) {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const disabled = !orgComplete || brandComplete;
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const timeZoneList = TimeHelper.GetTimeZoneList();

  return (
    <Card sx={getStartedCardSx(theme)}>
      <Stack spacing={2.5}>
        <Stack sx={getStartedHeaderSx(theme)}>
          <StepHeader
            icon={<AddBusinessIcon />}
            title={translate('get_started_page.brand.title', { defaultValue: 'Create brand' })}
            description={translate('get_started_page.brand.description', {
              defaultValue: 'Create the support brand your users and customers will see.',
            })}
            done={brandComplete}
          />
        </Stack>
        <Stack spacing={2} sx={{ maxWidth: 760 }}>
          <TextField
            fullWidth
            label={translate('get_started_page.brand.name_label', { defaultValue: 'Brand name' })}
            value={brandForm.brand_name}
            disabled={disabled}
            onChange={(event) => setBrandForm((prev) => ({ ...prev, brand_name: event.target.value }))}
          />
          <TextField
            fullWidth
            multiline
            minRows={3}
            label={translate('get_started_page.brand.description_label', { defaultValue: 'Brand description' })}
            value={brandForm.description}
            disabled={disabled}
            onChange={(event) => setBrandForm((prev) => ({ ...prev, description: event.target.value }))}
          />
          <TextField
            fullWidth
            select
            label={translate('get_started_page.brand.timezone_label', { defaultValue: 'TimeZone' })}
            name="timezone"
            value={brandForm.timezone || localTimeZone}
            disabled={disabled}
            onChange={(event) => setBrandForm((prev) => ({ ...prev, timezone: event.target.value }))}
          >
            <MenuItem value="UTC">UTC</MenuItem>
            <MenuItem value={localTimeZone}>
              {localTimeZone} :{' '}
              {translate('get_started_page.brand.current_local_timezone', { defaultValue: 'Current Local Timezone' })}
            </MenuItem>
            {timeZoneList.map((option) => (
              <MenuItem key={option.timeZone} value={option.timeZone}>
                {option.timeZone}: UTC{option.offset}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end">
          {!brandComplete && (
            <Button disabled={!orgComplete || savingStep === 'brand'} onClick={onSkip}>
              {translate('get_started_page.skip', { defaultValue: 'Skip' })}
            </Button>
          )}
          <LoadingButton
            variant="contained"
            loading={savingStep === 'brand'}
            disabled={disabled}
            onClick={onSave}
            sx={{ minWidth: 160 }}
          >
            {translate('get_started_page.brand.save_button', { defaultValue: 'Save brand' })}
          </LoadingButton>
        </Stack>
      </Stack>
    </Card>
  );
}
